export default {
    intro: '听声音，正确书写！',
    introHandwriting: '请听声音，用手正确地书写文字吧！',
    wordIndex: '第{index}个单词',
    common: {
        handwritingView: '查看手写',
    },
    student: {
        myAnswer: '我提交的答案',
        noAnswer: '没有提交答案。',
        answer: '正确答案',
        attemptNumber: '第{number}次',
        listen: '请仔细听！<br />请集中注意力！',
        teacherReading: '老师正在亲自朗读',
        listenDirect: '请认真听老师朗读的句子！',
        placeholder: '请输入正确答案。',
        wrongToast: '哎呀，答错了。请重新输入',
        writeEnd: '书写结束',
        submitAnswer: '提交答案',
        waitingStart: '请等待老师发出开始书写的信号！',
        threeWrong: '3次答题机会已全部用完...请等待老师公布正确答案！',
    },
    teacher: {
        setting: {
            activity: '活动内容',
            number: '编号',
            title: '听写 📝',
            message: '如果现在播放句子，学生们也能听到！',
            subMessage: '仍然要播放吗？',
            optionSubMessage: '播放一次后，将不再显示确认提示。',
            confirmText: '播放',
            addQuestion: {
                button: '添加题目',
                title: '添加听写题目',
                guide: '可以粘贴从外部复制的文本。每行输入一道题目。',
                notice: '※ 换行用于分隔题目，连续2个以上空格视为一个空格。',
                columnQuestion: '要添加的题目',
                cancelConfirm: {
                    title: '要删除已输入的题目吗？',
                    body: '取消后，已输入的题目将不会被添加并全部删除。\n是否继续？',
                },
                deleteConfirm: {
                    title: '要删除这道题目吗？',
                    body: '删除后，已添加的题目将从列表中移除。\n是否继续？',
                },
                registering: '正在添加题目...',
                noticeTitle: '提示',
                emptyData: '请至少输入一个题目。',
                partialFail: '由于TTS生成失败，{count}道题目未能添加。',
                duplicateSkip: '由于与已有题目相同，{count}道题目未能添加。',
                addFail: '添加题目失败。',
                deleteFail: '删除题目失败。',
                ttsSuccess: '已生成 TTS。',
                ttsFail: 'TTS 生成失败。',
            },
            inputMode: '答案输入方式',
            inputModeKeyboard: '键盘',
            inputModeHandwriting: '手写',
            tracing: '描写',
            previewGuide: '点击即可试听！',
            generateTts: '生成 TTS',
        },
        handwritingModal: {
            title: '各学生答案手写',
            answer: '正确答案',
            notAttempted: '未尝试',
        },
        question: '题目',
        intro: '请从左侧题目中选择单词。',
        ttsStart: '播放后开始书写',
        directReading: '亲自朗读',
        startWriting: '开始书写',
        completeWriting: '完成书写并公布答案',
        viewStudentResult: '查看全体学生结果',
        toast: {
            alreadyDone: '这是已经进行过的单词。',
            fiveSeconds: '开始书写后5秒才能完成书写。',
        },
        result: { title: '每题正确率', order: '顺序', question: '题目', answerRate: '正确率' },
    },
    table: { question: '题目', answerRate: '正确率', emptyMessage: '没有内容。' },
};
